import { useAtomValue } from "jotai";
import { useMemo, type FC } from "react";
import { segmentStateAtom } from "../../../moment/types/store";
import { useSegmentFields } from "../../hooks/use-segment-fields";
import { SegmentFiltersV3 } from "./segment-filters-v3";
import type { SegmentFiltersProps } from "./types";

export const SegmentFilters: FC<SegmentFiltersProps> = ({
  selectedSegment,
  disabled,
  showValidationErrors,
  isNew,
  onConfirm,
}) => {
  const segmentState = useAtomValue(segmentStateAtom);
  const segmentFields = useSegmentFields();

  const props = useMemo(() => {
    if (!segmentState || !selectedSegment || !segmentFields.data) return null;

    const deletedSegment =
      Boolean(selectedSegment?.id) &&
      Boolean(segmentState.segments.find((x) => x.id === selectedSegment?.id)?.deleted_at);

    return {
      disabled: disabled || !segmentState.isEditable(selectedSegment.id) || deletedSegment,
      showValidationErrors,
      isNew,
      onConfirm,
      selectedSegment,
    };
  }, [
    disabled,
    segmentState,
    selectedSegment,
    showValidationErrors,
    isNew,
    onConfirm,
    segmentFields,
  ]);

  if (!props) return null;

  return <SegmentFiltersV3 {...props} />;
};
